import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
const EVERY_MS = 60000;

/** Pings the server once a minute while a signed-in member has the tab open,
 *  so the account's time on site is on record (payment disputes). Stops while
 *  the tab is hidden. */
const UsageHeartbeat = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return undefined;
    let timer = null;

    const ping = () => {
      if (document.visibilityState !== 'visible') return;
      fetch(`${API}/api/track/heartbeat`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ path: window.location.pathname }),
        keepalive: true,
      }).catch(() => { /* never surface */ });
    };

    ping();
    timer = setInterval(ping, EVERY_MS);
    document.addEventListener('visibilitychange', ping);
    return () => {
      if (timer) clearInterval(timer);
      document.removeEventListener('visibilitychange', ping);
    };
  }, [user]);

  return null;
};

export default UsageHeartbeat;
